import {resolveFeatureFlags} from '../core/feature-flags.js';

const FLAG_MAP=Object.freeze({
  recipes_enabled:'recipes',
  planner_enabled:'planner',
  dymek_enabled:'dymek',
  sharing_enabled:'sharing',
  premium_enabled:'premium',
  community_enabled:'community',
  smokehouse_sync_enabled:'smokehouseSync',
  journal_sync_enabled:'journalSync'
});

function requireFrom(client){
  if(typeof client?.from!=='function')throw new TypeError('Supabase data client with from() is required');
  return client;
}

export function mapFeatureFlagRows(rows=[]){
  const remote={};
  for(const row of rows||[]){
    const local=FLAG_MAP[row?.key];
    if(local&&typeof row?.enabled==='boolean')remote[local]=row.enabled;
  }
  return resolveFeatureFlags(remote);
}

export function mapAppVersionRow(row){
  if(!row)return null;
  return Object.freeze({
    platform:String(row.platform||''),
    latestVersion:String(row.latest_version||'0.0.0'),
    minimumSupportedVersion:String(row.minimum_supported_version||'0.0.0'),
    message:String(row.release_message||''),
    storeUrl:row.store_url?String(row.store_url):''
  });
}

export function createRuntimeConfigAdapter({client,diagnostics}={}){
  const supabase=requireFrom(client);

  async function getFeatureFlags(){
    const {data,error}=await supabase.from('feature_flags').select('key,enabled');
    if(error){
      diagnostics?.capture?.('runtime-config.feature-flags',error);
      return resolveFeatureFlags();
    }
    return mapFeatureFlagRows(data);
  }

  async function getAppVersion(platform){
    const value=String(platform||'web').toLowerCase();
    const query=supabase.from('app_versions').select('platform,latest_version,minimum_supported_version,release_message,store_url').eq('platform',value).maybeSingle();
    const {data,error}=await query;
    if(error){
      diagnostics?.capture?.('runtime-config.app-version',error,{platform:value});
      return null;
    }
    return mapAppVersionRow(data);
  }

  return Object.freeze({getFeatureFlags,getAppVersion});
}
